// SPDX-License-Identifier: AGPL-3.0-or-later

import {createCallOverlay, readStoredOverlayPublisher, revokeCallOverlay} from '@app/features/coret/CoretMediaApi';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';

export function hasActiveCallOverlay(): boolean {
	return readStoredOverlayPublisher() != null;
}

export async function copyCurrentCallOverlayLink(): Promise<void> {
	try {
		const overlay = await createCallOverlay();
		await navigator.clipboard.writeText(overlay.overlayUrl);
		ToastCommands.createToast({
			type: 'success',
			children: 'Seu link Reactive permanente foi copiado. Cole como Fonte de navegador no OBS.',
		});
	} catch (error) {
		ToastCommands.createToast({
			type: 'error',
			children: error instanceof Error ? error.message : 'Não foi possível obter seu link Reactive.',
		});
	}
}

export async function disableCurrentCallOverlay(): Promise<void> {
	try {
		await revokeCallOverlay();
		ToastCommands.createToast({type: 'success', children: 'Link Reactive permanente desativado.'});
	} catch (error) {
		ToastCommands.createToast({
			type: 'error',
			children: error instanceof Error ? error.message : 'Não foi possível desativar o link.',
		});
	}
}
